import React from "react";
import { FiX, FiMessageSquare } from "react-icons/fi";
import { FaRegHeart, FaHeart } from "react-icons/fa";
import PhotoCarousel from "./PhotoCarousel";

export default function ProductDetailsModal({
  product,
  onClose,
  onContactSeller,
  liked,
  onToggleLike,
  likeCount,
}) {
  if (!product) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-lg w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="sticky top-0 bg-white z-10 p-4 border-b flex justify-between items-center">
          <h2 className="text-xl font-semibold text-[#363062]">
            {product.productTitle}
          </h2>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <span className="text-sm text-gray-500">{likeCount}</span>
              <button onClick={onToggleLike} className="text-2xl">
                {liked ? <FaHeart className="text-red-500" /> : <FaRegHeart />}
              </button>
            </div>
            <button
              onClick={onClose}
              className="p-2 hover:bg-gray-100 rounded-full transition-colors"
            >
              <FiX className="w-6 h-6" />
            </button>
          </div>
        </div>

        <div className="p-4">
          {/* Image Carousel */}
          <div className="mb-6 rounded-lg overflow-hidden">
            {product.images && product.images.length > 0 ? (
              <PhotoCarousel images={product.images} />
            ) : (
              <div className="w-full h-64 bg-gray-200 flex items-center justify-center">
                <span className="text-gray-400">No Image Available</span>
              </div>
            )}
          </div>

          {/* Category Badge */}
          {product.productCategories && product.productCategories[0] && (
            <div className="mb-4">
              <span className="bg-[#8FCD00] text-white text-sm font-bold px-3 py-1 rounded-lg">
                {product.productCategories[0]}
              </span>
            </div>
          )}

          {/* Price */}
          <div className="mb-6">
            <h3 className="text-2xl font-bold text-[#363062]">
              ₱{product.price}
            </h3>
          </div>

          {/* Product Details */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-gray-600 mb-2">
              Product Details
            </h4>
            <div className="space-y-2">
              {product.description && (
                <p className="text-gray-700 whitespace-pre-wrap">
                  {product.description}
                </p>
              )}
              {product.productCategories &&
                product.productCategories.length > 0 && (
                  <div className="flex flex-wrap gap-2 mt-2">
                    {product.productCategories.map((category, index) => (
                      <span
                        key={index}
                        className="bg-[#363062] bg-opacity-10 text-[#363062] text-sm px-3 py-1 rounded-full"
                      >
                        {category}
                      </span>
                    ))}
                  </div>
                )}
            </div>
          </div>

          {/* Seller Info */}
          <div className="mb-6">
            <h4 className="text-sm font-semibold text-gray-600 mb-2">
              Seller Information
            </h4>
            <p className="text-gray-700">{product.createdName}</p>
            {product.contactNumber && (
              <p className="text-gray-700">Contact: {product.contactNumber}</p>
            )}
            <p className="text-gray-500 text-sm mt-1">
              Listed on {new Date(product.createdAt).toLocaleDateString()}
            </p>
          </div>

          {/* Contact Button */}
          <div className="sticky bottom-0 bg-white py-4">
            <button
              onClick={onContactSeller}
              className="w-full bg-[#363062] hover:bg-[#363062]/90 text-white py-3 px-4 rounded-md transition-colors duration-300 flex items-center justify-center gap-2"
            >
              <FiMessageSquare className="w-5 h-5" />
              Contact Seller
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
